import InfoIcon from '@mui/icons-material/Info';

export default function Step4Confirm({ summaryItems = [], note }) {
    return (
        <div className="step-view">
            <div className="title-section">
                <h2>마지막 단계입니다</h2>
                <p>예약 정보를 확인하고 요청을 보내주세요.</p>
            </div>

            {summaryItems.length > 0 && (
                <div className="lr-summary-card">
                    {summaryItems.map((item) => (
                        <div className="lr-summary-card__row" key={item.label}>
                            <span className="lr-summary-card__label">{item.label}</span>
                            <span className="lr-summary-card__value">{item.value}</span>
                        </div>
                    ))}
                </div>
            )}

            <div className="precaution-card-wrap">
                <div className="precaution-card-wrap__header">
                    <InfoIcon className="icon" />
                    <span>꼭 확인해주세요</span>
                </div>
                <div className="precaution-card-wrap__list">
                    {note && <div className="item">{note}</div>}
                    <div className="item">수업 확정 전까지는 결제가 진행되지 않습니다.</div>
                    <div className="item">강사가 요청을 수락하면 결제 안내 메시지가 발송됩니다.</div>
                    <div className="item">결제가 완료되어야 최종 예약이 확정됩니다.</div>
                    <div className="item">노쇼 및 당일 취소 시 이용이 제한될 수 있습니다.</div>
                    <div className="item">해당 요청은 금일 자정까지 유효하며 자정까지 요청이 수락되지 않을 경우, 강습이 불가합니다. </div>
                </div>
            </div>

            <div className="notice-info-box">
                버킷리스트클래스는 안전한 다이빙 문화를 지향합니다. 강사님의 안내에 따라 강습을 진행해 주세요.
            </div>
        </div>
    );
}
